import { DefaultAttributeValue } from '@source-components-react/types';

export const defaultAttributeValues: DefaultAttributeValue[] = [
  {
    name: 'video-host-cloud-name',
    defaultValues: {},
  },
  {
    name: 'video-public-id',
    defaultValues: {},
  },
  {
    name: 'video-selector-3-resolutions',
    defaultValues: {
      all: 'main-sample-video',
    },
  },
  {
    name: 'video-poster-selector-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-controls-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-autoplay-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-loop-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-muted-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-playsinline-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-preload-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-width-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-height-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'video-transformations-3-resolutions',
    defaultValues: {},
  },
];
